export default "__VITE_ASSET__oei99Bk4__"